import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FarmCropImage crop-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseImage = _resolveComponent("BaseImage")!
  const _component_BaseTag = _resolveComponent("BaseTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_component_BaseTag, {
      key: `${_ctx.value}-${_ctx.slug}`,
      background: "#DAEBE1",
      "show-icon": "",
      round: ""
    }, {
      icon: _withCtx(() => [
        (_openBlock(), _createBlock(_component_BaseImage, {
          key: `${_ctx.value}-${_ctx.slug}`,
          force: "",
          loading: "lazy",
          class: "crop-item__icon",
          src: require(`images/icons/crops-icons/${_ctx.iconPathName}.svg`),
          alt: _ctx.iconPathName
        }, null, 8, ["src", "alt"]))
      ]),
      default: _withCtx(() => [
        _createTextVNode(" " + _toDisplayString(_ctx.value), 1)
      ]),
      _: 1
    }))
  ]))
}